import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions as mapActions } from 'state/ducks/map'
import Scrollbar from 'react-smooth-scrollbar'
import MapaInteractivoGL from 'utils/MapaInteractivoGL'
import { getFeatureInfo, getAttributes } from 'utils/apiConfig'
import useLayers from 'utils/useLayers'
import Popup from 'components/Popup'
import Pagination from '@material-ui/lab/Pagination'
import { Box, Typography, Divider } from '@material-ui/core'
import { getLayerName, getLayer } from 'utils/configQueries'
import usePagination from './Pagination'

const FeaturePopup = ({ features, attributes }) => {
  const info = features?.features?.map(({ properties }) => Object.entries(properties))
  const labels = []
  const attributos = attributes?.result.map(({ attribute, attribute_label }) => labels[attribute] = attribute_label)
  const text = []
  info.map((item) => item?.forEach((item1, e) => {
    labels[item1[0]] == null ? text[e] = item1 : text[e] = [labels[item1[0]], item1[1]]
  }))
  return (

    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        position: 'relative',
        width: 'auto!important',
        paddingLeft: 10
      }}
    >
      <Scrollbar style={{ height: 200, width: 200, padding: 0 }}>
        {text?.map(([key, value]) => (
          <Box style={{
            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 10
          }}
          >

            <Typography style={{ alignSelf: 'flex-start', fontSize: 12, fontWeight: 'bold' }}>
              {key}
              :
            </Typography>
            <Typography style={{ fontSize: 12, paddingLeft: 4, textAlign: 'end' }}>
              {value}
            </Typography>
          </Box>
        ))}
      </Scrollbar>
    </Box>
  )
}

const FeaturesInfo = () => {
  const { map } = MapaInteractivoGL()
  const clickedPoint = useSelector((state) => state.map.clickedPoint)
  const filterOptions = useSelector((state) => state.layers?.filters)
  const coord = useSelector((state) => state.map.selectedCoords)
  const layersIds = useSelector((state) => state.layers?.ids)
  const showLine = useSelector((state) => state.measure?.showLine)
  const [page, setPage] = useState(1)
  const { current } = useRef({
    clickedPoint: { x: 0, y: 0 },
    layersIds: []
  })

  const [pointFeatures, setPointFeatures] = useState([])
  const [attributes, setAttributes] = useState([])
  useEffect(() => {
    if (map && clickedPoint && coord) {
      const { x, y } = clickedPoint

      const isCurrentCoords = () => x === current.x && y === current.y
      const isCurrentLayersIds = () => layersIds.length === current.layersIds.length

      if (isCurrentCoords() && isCurrentLayersIds()) {
        return
      }
      current.layersIds = []
      layersIds.map((id) => {
        current.layersIds.push(id)
      })
      current.x = x
      current.y = y
      setAttributes([])
      setPointFeatures([])

      if (layersIds.length === 0) {
        return
      }
      const { offsetWidth: width, offsetHeight: height } = document.getElementById('map')
      const bbox = map.getBounds().toArray().join(',')
      const fechAttribute = Promise.allSettled(
        layersIds.map((id) => getAttributes(getLayer(id).outer_layer ? getLayer(id).outer_layer : getLayer(id).id_geonode).then((result) => ({ result, id })))
      )
      fechAttribute.then((data) => data
        .filter(({ status, value }) => status === 'fulfilled'
        && value)
        .map(({ value }) => value))
        .then((data) => {
          setAttributes(data)
        })
      const featuresPromises = Promise.allSettled(
        current.layersIds.map((layerId) => getFeatureInfo({
          layer: `${getLayer(layerId)?.outer_layer ? getLayer(layerId)?.outer_layer : getLayer(layerId).title}`, x: current.x, y: current.y, height, width, bbox,
          filtro: filterOptions[layerId]
        })
          .then(({ features }) => ({ layerId, features })))
      )
      featuresPromises
        .then((data) => data
          .filter(({ status, value }) => status === 'fulfilled'
            && value?.features?.length)
          .map(({ value }) => value))
        .then((data) => {
          if (isCurrentCoords() && isCurrentLayersIds()) {
            setPointFeatures(data)
            setPage(1)
          }
        })
    }
  }, [clickedPoint, map, layersIds, current])

  // const dispatch = useDispatch()
  // useEffect(() => {
  //   if (layersIds.length === 0 && coord != null) {
  //     dispatch(mapActions.removeCoords())
  //   }
  // }, [layersIds.length, coord, dispatch])

  const { layers } = useLayers()
  const PER_PAGE = 1

  const count = Math.ceil(pointFeatures?.length / PER_PAGE)
  const DATA = usePagination(pointFeatures, PER_PAGE)

  const handleChange = (e, p) => {
    setPage(p)
    DATA.jump(p)
  }
  return (
    <>
      {(pointFeatures.length > 0 && !showLine && clickedPoint && pointFeatures[page - 1] !== undefined) && (
        <Popup coords={coord} offset={10}>
          <div>
            <div style={{ paddingTop: 10 }}>
              <Box>
                <Typography
                  style={{
                    marginLeft: 5,
                    maxWidth: 200,
                    fontWeight: 'bold',
                    left: 0,
                    paddingTop: 12,
                    textAlign: 'center',
                    fontSize: 13,
                    color: '#0B72BB'
                  }}
                >
                  {layers?.find(({ id }) => id === pointFeatures[page - 1]?.layerId)?.name}
                </Typography>
                <Divider style={{ width: 200, padding: 1, margin: 5 }} />
              </Box>
              <FeaturePopup
                features={pointFeatures[page - 1]}
                attributes={attributes[page - 1]}
              />
            </div>
            {count > 1 && <Divider style={{ width: 200, padding: 1, margin: 5 }} />}
            {count > 1 && (
              <Pagination
                style={{ backgraundColor: 'white' }}
                count={count}
                page={page}
                onChange={handleChange}
              />
            )}
          </div>
        </Popup>
      )}
    </>
  )
}

export default FeaturesInfo
